import { render, staticRenderFns } from "./JoinVerifyForm.vue?vue&type=template&id=cc2f4674&scoped=true"
import script from "./JoinVerifyForm.vue?vue&type=script&lang=js"
export * from "./JoinVerifyForm.vue?vue&type=script&lang=js"
import style0 from "./JoinVerifyForm.vue?vue&type=style&index=0&id=cc2f4674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2f4674",
  null
  
)

export default component.exports